import React, { useState, useEffect } from 'react';
import { Card, Button, Image, Spinner } from 'react-bootstrap';
import { FaHeart, FaRegHeart, FaRegComment } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import dummyIcon from 'assets/img/dpmain.png';

const FeedCard = ({ post }) => {
  const [imageError, setImageError] = useState(false);
  const [isLiked, setIsLiked] = useState(post?.is_liked || false);
  const [likeCount, setLikeCount] = useState(post?.likes_count || 0);
  const [isFollowed, setIsFollowed] = useState(post?.post_user_detail?.is_followed || false);
  const [followLoading, setFollowLoading] = useState(false);


  useEffect(() => {
    setIsLiked(post?.is_liked || false);
    setLikeCount(post?.likes_count || 0);
    setIsFollowed(post?.post_user_detail?.is_followed || false);
  }, [post]);

  if (!post) return null;

  const user = post.post_user_detail || {};
  const handle = user?.user_handle || user?.subtitle;

  const profileLink = user?.is_safari_operator
    ? `/operator/${handle}/profile`
    : `/profile/user/${handle}`;

  const handleLikeToggle = async () => {
    const newLiked = !isLiked;
    setIsLiked(newLiked);
    setLikeCount((prev) => prev + (newLiked ? 1 : -1));

  };

  const handleFollowToggle = async () => {
    setFollowLoading(true);
    try {
      const newFollowed = !isFollowed;
      setIsFollowed(newFollowed);

    } catch (error) {
      console.error('Follow toggle failed:', error);
    }
    setFollowLoading(false);
  };

  return (
    <Card className="mb-4 border-0 shadow-sm rounded-4 overflow-hidden">
      <Card.Body>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex">
            <Link to={profileLink} className="text-decoration-none d-flex align-items-center">
              <Image
                src={!imageError && user.image ? user.image : dummyIcon}
                onError={() => setImageError(true)}
                roundedCircle
                width={45}
                height={45}
                alt="User"
              />
              <div className="ms-2">
                <h6 className="mb-0 fw-semibold text-dark">{user.name || 'Unknown'}</h6>
                <small className="text-muted">@{user.subtitle || 'user'}</small>
              </div>
            </Link>
          </div>

          <Button
            variant={isFollowed ? 'secondary' : 'outline-secondary'}
            size="sm"
            className="rounded-pill px-3"
            onClick={handleFollowToggle}
            disabled={followLoading}
          >
            {followLoading ? <Spinner animation="border" size="sm" /> : isFollowed ? 'Unfollow' : 'Follow'}
          </Button>
        </div>

        {/* Caption */}
        {post?.caption && <p className="my-2">{post.caption}</p>}

        {/* Image */}
        {post?.full_image_path && (
          <Image
            src={post.full_image_path}
            onError={(e) => (e.target.src = '/img/placeholder.jpg')}
            fluid
            rounded
            className="my-2 feedcard-img"
            alt="Feed"
            onDoubleClick={handleLikeToggle}
            style={{ cursor: 'pointer' }}
          />

        )}

        {/* Meta */}
        <div className="d-flex justify-content-between text-muted small mt-2">
          <div style={{ cursor: 'pointer' }} onClick={handleLikeToggle}>
            {isLiked ? (
              <FaHeart size={20} className="me-1 text-danger" />
            ) : (
              <FaRegHeart size={20} className="me-1" />
            )}
            {likeCount}
            &nbsp;&nbsp;
            <FaRegComment size={20} className="me-1" />
            {post?.comments_count || 0}
          </div>
          <div>{post?.start_date || ''}</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default FeedCard;
